import { render, staticRenderFns } from "./ImgItem.vue?vue&type=template&id=131db74e&scoped=true"
import script from "./ImgItem.vue?vue&type=script&lang=js"
export * from "./ImgItem.vue?vue&type=script&lang=js"
import style0 from "./ImgItem.vue?vue&type=style&index=0&id=131db74e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131db74e",
  null
  
)

export default component.exports